import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import './Profile.css';

// import TopUpModal from './components/TopUpModal'; // путь поправь если нужно


const Profile = ({ setUsername }) => {
  const { t: translate } = useTranslation();
  const navigate = useNavigate();
  const [profile, setProfile] = useState({});
  const [file, setFile] = useState(null);
  const [localUsername, setLocalUsername] = useState('');
  const [email, setEmail] = useState(''); // 👈 новый email
  const token = localStorage.getItem('token'); 
  const [avatarVer, setAvatarVer] = useState(0); // 👈 добавили
  const [preview, setPreview] = useState(null);

  const API_ORIGIN = process.env.REACT_APP_API_URL || 'http://localhost:5000';










    // ↓↓↓ ДОБАВЬ ЭТО
  const normalizeAvatarPath = (raw) => {
    if (!raw) return null;
    // приводим к прямым слэшам
    const s = String(raw).replace(/\\/g, '/');

    // если уже содержит /uploads/.. — вытаскиваем хвост начиная с uploads
    const m = s.match(/\/?uploads\/.*$/i);
    if (m) {
      return '/' + m[0].replace(/^\/+/, '');
    }

    // иначе берём только имя файла и вешаем в /uploads/avatars/
    const filename = s.split('/').pop();
    return filename ? `/uploads/avatars/${filename}` : null;
  };



    useEffect(() => {
    fetchProfile();
  }, [token]); // ← было [], делаем [token]



  // где-то рядом с другими useEffect в Profile.jsx
useEffect(() => {
  const h = () => fetchProfile();
  window.addEventListener('balance-updated', h);
  return () => window.removeEventListener('balance-updated', h);
}, []);


    useEffect(() => {
    if (profile?.avatar) setAvatarVer(v => v + 1);
  }, [profile.avatar]);

  const fetchProfile = async () => {
    // const res = await axios.get('http://127.0.0.1:5000/api/profile', {
    const res = await axios.get(`${API_ORIGIN}/api/auth/profile`, {
  headers: { Authorization: `Bearer ${token}` }
});
console.log('[Profile] GET /api/auth/profile →', res.data); // ← ДОБАВЬ ЭТО
    setProfile(res.data);
    setLocalUsername(res.data.username);
    setEmail(res.data.email); // 👈 сохраняем email
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  useEffect(() => {
    if (file) {
      const objectUrl = URL.createObjectURL(file);
      setPreview(objectUrl);
      return () => URL.revokeObjectURL(objectUrl);
    } else {
      setPreview(null);
    }
  }, [file]);


  const handleSave = async () => {
  // 👇 запоминаем, менял ли игрок аватар именно сейчас
  const hadNewAvatar = Boolean(file);

  const formData = new FormData();
  if (file) formData.append('avatar', file);
  formData.append('username', localUsername);
  formData.append('email', email); // email всё равно неизменяемый, но пусть будет

  try {
    const res = await axios.put(`${API_ORIGIN}/api/auth/profile`, formData, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    console.log('[Profile] PUT /api/auth/profile →', res.data);

    const updated = res.data.user;
    setProfile(updated);
    setLocalUsername(updated.username);
    setUsername(updated.username);
    localStorage.setItem('username', updated.username);
    setFile(null);

    localStorage.setItem('avatar', updated.avatar || '');

    // 🔔 сообщаем всему приложению, что аватар обновился
    window.dispatchEvent(new CustomEvent('avatar-updated', {
      detail: { avatar: updated.avatar }
    }));

    setAvatarVer(v => v + 1);

    // 👉 если игрок загружал новый аватар — отправляем его в "Квесты"
    if (hadNewAvatar) {
      navigate('/quests', {
        state: {
          fromProfileAvatarSaved: true   // этот флаг потом прочитаем в компоненте "Квесты"
        }
      });
    }
  } catch (err) {
    console.error('Ошибка при обновлении профиля:', err);
  }
};


//   const handleSave = async () => {
//     const formData = new FormData();
//     if (file) formData.append('avatar', file);
//     formData.append('username', localUsername);
//     formData.append('email', email); // 👈 добавляем email (если хочешь редактируемым)

//     try {
//       // const res = await axios.put('http://127.0.0.1:5000/api/profile', formData, {
//        const res = await axios.put(`${API_ORIGIN}/api/auth/profile`, formData, {
        
//   headers: {
//     // 'Content-Type': 'multipart/form-data',
//     Authorization: `Bearer ${token}`
    
//   }
  
// });
// console.log('[Profile] PUT /api/auth/profile →', res.data); // ← ДОБАВЬ ЭТО

//       const updated = res.data.user;
//       setProfile(updated);
//       setLocalUsername(updated.username);
//       setUsername(updated.username);
//       localStorage.setItem('username', updated.username);
//       setFile(null);

//       localStorage.setItem('avatar', updated.avatar || '');

//       // 🔔 сообщаем всему приложению, что аватар обновился
//       window.dispatchEvent(new CustomEvent('avatar-updated', {
//         detail: { avatar: updated.avatar }
//       }));

//       setAvatarVer(v => v + 1);
//     } catch (err) {
//       console.error("Ошибка при обновлении профиля:", err);
//     }
//   };

   return (
    <div className="profile-account-root">
      <div className="profile-card">
        <div className="profile-card-header">
          <h3 className="profile-card-title">{translate('profile.account.title')}</h3>
          <p className="profile-card-subtitle">
           {translate('profile.account.subtitle')}
          </p>
        </div>


 {!profile.avatar && !preview && (
        <div className="profile-quest-hint">
          <strong>{translate('profile.account.firstQuestTitle')}</strong>{' '}
          {translate('profile.account.firstQuestText')}
        </div>
      )}

        <div className="profile-card-body">
          {/* Левая колонка — аватар и загрузка файла */}
          <div className="profile-avatar-column">
            <div className="profile-avatar-wrapper">
              {preview ? (
                <img src={preview} alt="avatar-preview" />
              ) : (
                profile.avatar &&
                  (() => {
                    const normalized = normalizeAvatarPath(profile.avatar);
                    if (!normalized) {
                      return <div className="profile-avatar-placeholder">?</div>;
                    }

                    const src = `${API_ORIGIN}${normalized}?v=${avatarVer}`;
                    console.log('[Profile] IMG src =', src);

                    return (
                      <img
                        src={src}
                        alt="avatar"
                        onError={(e) => {
                          console.error(
                            '[Profile] IMG LOAD ERROR',
                            e.currentTarget.src
                          );
                        }}
                      />
                    );
                  })()
              )}

              {/* Если вообще нет аватара */}
              {!preview && !profile.avatar && (
                <div className="profile-avatar-placeholder">?</div>
              )}
            </div>

            <label className="profile-file-label">
              <input
                type="file"
                className="profile-file-input"
                accept="image/*"
                onChange={(e) => setFile(e.target.files[0])}
              />
              <span>{translate('profile.account.uploadAvatar')}</span>
            </label>

            {file && (
              <div className="profile-file-name">
                {file.name}
              </div>
            )}

            <div className="profile-avatar-hint">
              {translate('profile.account.avatarHint')}
            </div>
          </div>

          {/* Правая колонка — поля профиля */}
          <div className="profile-form-column">
            <div className="profile-form-row">
              <label className="profile-label" htmlFor="profile-username">
                {translate('profile.account.gameName')}
              </label>
              <input
                id="profile-username"
                className="profile-input"
                value={localUsername}
                onChange={(e) => setLocalUsername(e.target.value)}
                disabled
                placeholder={translate('profile.account.nicknamePlaceholder')}
              />
            </div>

            <div className="profile-form-row">
              <label className="profile-label" htmlFor="profile-email">
                Email
              </label>
              <input
                id="profile-email"
                className="profile-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled
              />
            </div>

            <div className="profile-save-row">
              <button
                type="button"
                onClick={handleSave}
                className="profile-save-button"
              >
                {translate('profile.account.saveChanges')}
              </button>
              <div className="profile-save-hint">
                {translate('profile.account.saveHint')}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

};

export default Profile;
